import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { FormControl, InputLabel, Select as MuiSelect, MenuItem, FormHelperText } from "@mui/material";


  const StyledTextField = styled((props) => (
    <TextField  {...props} 
      inputProps={{ sx: { backgroundColor: '#fff', padding: '5px' } }} 
      />
      ))(({ theme }) => ({

      }));

  export default function AxionSelect(props) {
    const { name, label, sx, value, disabled, defaultValue, error = null, onChange, options, showNoneOption = true, noneText = ' ', ...other } = props;

    return (
      <StyledTextField
          id={name}
          select
          label={label}
          defaultValue={defaultValue}
          value={value}
          sx={sx}
          onChange={onChange}
          variant="standard"
          disabled={disabled}
          
      >
          { showNoneOption && <MenuItem key={0} value={0}>{noneText}</MenuItem> }
          { options.map((option) => ( <MenuItem key={option.id} value={option.id}>{option.title}</MenuItem>)) }
      </StyledTextField>
    );
    
  }
  